import {
  Home,
  BarChart3,
  ClipboardCheck,
  Heart,
  DollarSign,
  FileText,
  Package,
  Settings,
} from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

const navItems = [
  { to: '/', icon: Home, label: 'Home', end: true },
  { to: '/engagement', icon: BarChart3, label: 'Engagement', end: false },
  { to: '/compliance', icon: ClipboardCheck, label: 'Compliance', end: false },
  { to: '/outcomes', icon: Heart, label: 'Outcomes', end: false },
  { to: '/roi', icon: DollarSign, label: 'ROI', end: false },
  { to: '/reports', icon: FileText, label: 'Reports', end: false },
  { to: '/launch-kit', icon: Package, label: 'Launch Kit', end: false },
  { to: '/settings', icon: Settings, label: 'Settings', end: false },
];

export function Sidebar() {
  return (
    <aside className="hidden w-64 shrink-0 border-r bg-card lg:block">
      <div className="flex h-full flex-col">
        <div className="flex items-center gap-3 border-b px-4 py-4">
          <img src="/logo.png" alt="Metaonia" className="h-10 w-10 object-contain" />
          <div className="flex flex-col">
            <span className="text-sm font-bold text-primary">Metaonia</span>
            <span className="text-xs text-muted-foreground">HR Dashboard</span>
          </div>
        </div>
        <nav className="flex-1 space-y-1 p-4">
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                )
              }
            >
              <Icon className="h-5 w-5" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </aside>
  );
}

export { navItems };
